<img [src]="_src" *ngIf="_src !=''; else loading;"> 

<ng-template #loading>
  <ion-spinner></ion-spinner>
</ng-template>